"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketLocationInput_1 = require("./GetBucketLocationInput");
var GetBucketLocationOutput_1 = require("./GetBucketLocationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketLocation = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketLocation",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?location"
    },
    input: {
        shape: GetBucketLocationInput_1.GetBucketLocationInput
    },
    output: {
        shape: GetBucketLocationOutput_1.GetBucketLocationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketLocation.js.map